export const CONFIG = {
    year: 17,
    data: "data/pumpkins17.json",
    api: "http://pumpkin.gskinner.com/pumpkin.php",
    testing: false
}


// WEBPACK FOOTER //
// ./src/config.js